// src/pages/MyRankings.jsx
import React, { useState } from "react";
import MyRankings_Cards from "./MyRankings_Cards.jsx";
import MyRankings_Decks from "./MyRankings_Decks.jsx";

function MyRankings({ user }) {
  const [view, setView] = useState("cards");

  return (
    <div className="rankings-page">
      <h1 className="main-title">My Rankings</h1>

      <div className="rankings-toggle">
        <button
          className={`button rankings-toggle-btn ${view === "cards" ? "is-active" : ""}`}
          onClick={() => setView("cards")}
          type="button"
        >
          Card Rankings
        </button>

        <button
          className={`button rankings-toggle-btn ${view === "decks" ? "is-active" : ""}`}
          onClick={() => setView("decks")}
          type="button"
        >
          Deck Rankings
        </button>
      </div>

      <div className="rankings-content">
        {view === "cards" ? (
          <MyRankings_Cards user={user} />
        ) : (
          <MyRankings_Decks user={user} />
        )}
      </div>
    </div>
  );
}

export default MyRankings;
